import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {useLocation, useParams} from 'react-router-dom'
import {RouteName} from '../../../../../app/Utils/Constant/ConstantForWebsite'
import {useSelector} from 'react-redux'
import {getAllUserDetails} from '../../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

const DefaultTitle: FC = () => {
  const location = useLocation()
  const params = useParams()

  const userData: any = useSelector(getAllUserDetails)

  let pathName = location.pathname
  let customTitle = null

  if (Object.keys(params).length > 1) {
    for (const key in params) {
      if (!params.hasOwnProperty(key) || key === '*') {
        continue
      }
      const value = params[key] as string

      pathName = pathName.replaceAll(value, `:${key}`)
    }
  }

  if (location.state) {
    const state = location.state as any
    if (state.title) {
      customTitle = state.title
    }
  }

  const [isShareCredit, setIsShareCredit] = useState(false)
  const [isSubClintAccount, setIsSubClientAccount] = useState(false)

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      setIsShareCredit(userData._id !== userData.ownerId)
      setIsSubClientAccount(true)
    }
  }, [userData])

  const getFirstBreadcrumbTitle = (title: string, lastTitle: string) => {
    if (isSubClintAccount) {
      return 'Home - Sub Client Account'
    }
    return title
  }

  const getLastBreadcrumbTitle = (lastTitle: string) => {
    if (lastTitle === 'Credit History' && isSubClintAccount) {
      if (isShareCredit) {
        return 'Shared Credit'
      }
        return 'Not Shared Credit'
    }
    return lastTitle
  }

  return (
    <div
      id='kt_page_title'
      // data-kt-swapper='true'
      // data-kt-swapper-mode='prepend'
      // data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx('page-title d-flex ')}
    >
      {/* begin::Title */}
      {true && (
        <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3'>
          {RouteName?.[pathName]?.[0]}
          {/* {param?.pathname?.split('/')?.length > 2
            ? param?.pathname?.split('/')?.[2]
            : param?.pathname?.split('/')?.[1]} */}
        </h1>
      )}
      {/* end::Title */}

      {
        <>
          {true && <span className='h-20px border-gray-200 border-start mx-4'></span>}
          <ul className='breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1'>
            <li className={'breadcrumb-item text-muted'}>
              <span className='text-muted text-hover-primary'>
                {getFirstBreadcrumbTitle(RouteName?.[pathName]?.[1], RouteName?.[pathName]?.[0])}
              </span>
            </li>
            <li className={'breadcrumb-item text-muted'}>
              <span className='bullet bg-gray-200 w-5px h-2px'></span>
            </li>

            {/* {param?.pathname?.split('/').length > 2 ? (
              <>
                <li className={'breadcrumb-item text-muted'}>
                  <span className='text-muted text-hover-primary'>
                    {param?.pathname?.split('/')?.[1]}
                  </span>
                </li>
                <li className={'breadcrumb-item text-muted'}>
                  <span className='bullet bg-gray-200 w-5px h-2px'></span>
                </li>
              </>
            ) : (
              <>
                <li className={'breadcrumb-item text-muted'}>
                  <span className='text-muted text-hover-primary'>Home</span>
                </li>
                <li className={'breadcrumb-item text-muted'}>
                  <span className='bullet bg-gray-200 w-5px h-2px'></span>
                </li>
              </>
            )} */}
            <li className='breadcrumb-item text-dark'>
              {customTitle != null
                ? customTitle
                : getLastBreadcrumbTitle(RouteName?.[pathName]?.[0])}
              {/* {param?.pathname?.split('/')?.length > 2
                ? param?.pathname?.split('/')?.[2]
                : param?.pathname?.split('/')?.[1]} */}
            </li>
          </ul>
        </>
      }
    </div>
  )
}

export {DefaultTitle}
